import React, { memo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import FormProviderMC from '../../../../components/FormProviderMC';
import DropzoneFileUploader from '../../../../components/DropzoneFileUploader';
import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';
import { buildDeliveryProofSchema } from '../../schemas/deliveryProofSchema';

const COMPONENT_KEY = 'DeliveryProofModal';

const DeliveryProofModal = memo(({
  onSave
}) => {
  const { t } = useTranslation('Orders');
  const { t: tCommon } = useTranslation('Common');
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);

  const formMethods = useForm({
    resolver: zodResolver(buildDeliveryProofSchema(tCommon)),
    defaultValues: {
      attachment: []
    }
  });

  const onClose = () => {
    dispatch({
      type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR,
      payload: { componentKey: COMPONENT_KEY }
    });
  };

  const handleSave = async () => {
    const attachment = formMethods.getValues('attachment');
    const file = attachment?.length > 0 && attachment[0] ? attachment[0] : null;

    setSaving(true);
    try {
      await onSave(file);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={t('delivery_status_modal.title')}
        closeAction={onClose}
        submitAction={handleSave}
        submitLabel={t('delivery_status_modal.save')}
        submitDisabled={saving}
      >
        <FormProviderMC methods={formMethods}>
          <DropzoneFileUploader
            name="attachment"
            accept=".png,.jpg,.jpeg,.pdf"
            placeholder={t('delivery_status_modal.attachment_hint')}
            className="tw-mb-3"
            fileContainerClassName="tw-bg-gray-50 tw-border tw-border-gray-200 tw-rounded-xl tw-px-3"
            defaultValue={formMethods.watch('attachment')}
          />
          <p className="tw-text-xs tw-text-gray-500 tw-leading-relaxed">
            {t('delivery_status_modal.optional_notice')}
          </p>
        </FormProviderMC>
      </RightModalLayout>
    </div>
  );
});

DeliveryProofModal.displayName = 'DeliveryProofModal';

export default DeliveryProofModal;
